import { useRef, useCallback } from 'react';

var useDebounce = function useDebounce(callback) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ref = useRef(null);
  var debouncedCallback = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    ref.current && clearTimeout(ref.current);
    ref.current = setTimeout(function () {
      return callback.apply(undefined, args);
    }, wait);
  }, [callback, wait]);
  return debouncedCallback;
};

export { useDebounce as default };
//# sourceMappingURL=index.js.map
